<div class="gift">
  <div class="gift__image">
    <img class="gift__image-img" loading="lazy" [src]="image()" alt="Gift Card" />
  </div>

  <div class="gift__content">
    <div class="gift__content-general gift-general">
      <div class="gift-general__content">
        @if (recipientName()) {
          <span class="gift-general__content-recipient">
            {{ recipientName() }}, you got
          </span>
        }

        <span class="gift-general__content-amount">
          {{ amount() | currency: 'USD' : '$' : '1.0-2' }}
        </span>
      </div>
    </div>

    <div class="gift__content-sender gift-sender">
      @if (senderName()) {
        <div class="gift-sender__field">
          <span class="gift-sender__field-key">From</span>
          <span class="gift-sender__field-value">{{ senderName() }}</span>
        </div>
      }

      @if (message()) {
        <div class="gift-sender__field">
          <span class="gift-sender__field-key">Message</span>
          <span class="gift-sender__field-value">{{ message() }}</span>
        </div>
      }
    </div>
  </div>
</div>
